import React from 'react';
import { CURRENCIES } from '@/data/currencies';

export default function CurrencyToggle({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-lg border border-white/10 bg-white/[0.03]">
      {CURRENCIES.map((c) => {
        const active = c.code === value;
        return (
          <button
            key={c.code}
            type="button"
            onClick={() => onChange(c.code)}
            aria-pressed={active}
            className={`px-3.5 h-9 rounded-md text-[11px] font-semibold uppercase tracking-[0.14em] transition-colors ${
              active ? 'bg-[#2563EB] text-white' : 'text-white/50 hover:text-white'
            }`}
          >
            {c.code}
          </button>
        );
      })}
    </div>
  );
}